import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mic, MicOff, Video as VideoIcon, VideoOff, PhoneOff, MessageCircle, SwitchCamera } from 'lucide-react';
export function VideoCallScreen() {
  const navigate = useNavigate();
  const [isMuted, setIsMuted] = useState(false);
  const [isVideoOff, setIsVideoOff] = useState(false);
  const [timer, setTimer] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setTimer(prev => prev + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, '0');
    const s = (seconds % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };
  const handleEndCall = () => {
    navigate('/visit-summary');
  };
  return <div className="min-h-screen bg-gray-900 relative flex flex-col" data-id="element-1771">
      {/* Main Video Area (Doctor) */}
      <div className="absolute inset-0 z-0" data-id="element-1772">
        <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?auto=format&fit=crop&q=80&w=600&h=800" alt="Doctor Video" className="w-full h-full object-cover opacity-90" data-id="element-1773" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/80" data-id="element-1774"></div>
      </div>

      {/* Header */}
      <div className="relative z-10 pt-12 px-6 flex justify-between items-start" data-id="element-1775">
        <div data-id="element-1776">
          <h2 className="text-white font-bold text-lg shadow-sm" data-id="element-1777">
            Dr. Amina Bello
          </h2>
          <div className="flex items-center mt-1" data-id="element-1778">
            <div className="w-2 h-2 bg-status-emergency rounded-full animate-pulse mr-2" data-id="element-1779"></div>
            <span className="text-white/90 text-sm font-medium" data-id="element-1780">
              {formatTime(timer)}
            </span>
          </div>
        </div>
        <button className="w-10 h-10 bg-black/30 backdrop-blur-md rounded-full flex items-center justify-center text-white" data-id="element-1781">
          <SwitchCamera size={20} data-id="element-1782" />
        </button>
      </div>

      {/* Self View (Picture in Picture) */}
      <div className="absolute top-24 right-6 w-28 h-40 bg-gray-800 rounded-xl overflow-hidden border-2 border-white/20 shadow-xl z-20" data-id="element-1783">
        {!isVideoOff ? <img src="https://images.unsplash.com/photo-1531384441138-2736e62e0919?auto=format&fit=crop&q=80&w=200&h=300" alt="Self View" className="w-full h-full object-cover" data-id="element-1784" /> : <div className="w-full h-full flex items-center justify-center bg-gray-800" data-id="element-1785">
            <VideoOff size={24} className="text-white/50" data-id="element-1786" />
          </div>}
      </div>

      {/* Controls */}
      <div className="relative z-10 mt-auto pb-10 px-6 flex justify-center items-center space-x-6" data-id="element-1787">
        <button onClick={() => setIsMuted(!isMuted)} className={`w-14 h-14 rounded-full flex items-center justify-center backdrop-blur-md transition-all ${isMuted ? 'bg-white text-gray-900' : 'bg-white/20 text-white'}`} data-id="element-1788">
          {isMuted ? <MicOff size={24} data-id="element-1789" /> : <Mic size={24} data-id="element-1790" />}
        </button>

        <button onClick={() => setIsVideoOff(!isVideoOff)} className={`w-14 h-14 rounded-full flex items-center justify-center backdrop-blur-md transition-all ${isVideoOff ? 'bg-white text-gray-900' : 'bg-white/20 text-white'}`} data-id="element-1791">
          {isVideoOff ? <VideoOff size={24} data-id="element-1792" /> : <VideoIcon size={24} data-id="element-1793" />}
        </button>

        <button onClick={handleEndCall} className="w-16 h-16 rounded-full bg-status-emergency text-white flex items-center justify-center shadow-lg hover:bg-red-600 transition-colors" data-id="element-1794">
          <PhoneOff size={28} data-id="element-1795" />
        </button>

        <button className="w-14 h-14 rounded-full bg-white/20 backdrop-blur-md text-white flex items-center justify-center relative" data-id="element-1796">
          <MessageCircle size={24} data-id="element-1797" />
          <span className="absolute top-0 right-0 w-3 h-3 bg-brand-primary rounded-full border-2 border-gray-900" data-id="element-1798"></span>
        </button>
      </div>
    </div>;
}